import React from 'react';
import type { FC } from 'react';

import { BUTTON_TEXT } from '../constants';
import { usePaginationContext } from '../provider';

import type { TPaginationShowMoreButton } from './models';

export const PaginationShowMoreButton: FC<TPaginationShowMoreButton> = ({
    Button,
    buttonSettings,
    buttonText = BUTTON_TEXT,
    disabled = false,
    children,
    className,
}) => {
    const { currentPageNumber, handleShowMoreButtonClick: onClick, pages } = usePaginationContext();

    // До предпоследней странички кнопку можно показывать
    if (currentPageNumber <= pages - 1) {
        return (
            <Button
                className={className}
                dataTestId="button-show-more"
                disabled={disabled}
                onClick={onClick}
                {...buttonSettings}
            >
                {children || buttonText}
            </Button>
        );
    }

    return null;
};
